import { Controller } from "@hotwired/stimulus"

// Mobile nav drawer for the authenticated app layout. The sidebar is
// fixed-positioned and offscreen by default below `md:`; this controller
// slides it in over a backdrop and locks body scroll while open.
// Above the md breakpoint the sidebar is static and these actions are no-ops
// in practice (the CSS classes the controller toggles are mobile-only).
export default class extends Controller {
  static targets = ["drawer", "backdrop"]

  // Fresh-mount housekeeping: each Turbo visit reuses <body>, so a previous
  // page that locked scroll on drawer-open could leave the lock in place.
  // Strip it on connect so the new page starts unlocked regardless.
  connect() {
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    event?.preventDefault()
    this.drawerTarget.classList.remove("-translate-x-full")
    this.drawerTarget.classList.add("translate-x-0")
    this.drawerTarget.setAttribute("aria-hidden", "false")
    this.backdropTarget.classList.remove("hidden")
    document.body.classList.add("overflow-hidden")
  }

  close(event) {
    event?.preventDefault()
    this.drawerTarget.classList.add("-translate-x-full")
    this.drawerTarget.classList.remove("translate-x-0")
    this.drawerTarget.setAttribute("aria-hidden", "true")
    this.backdropTarget.classList.add("hidden")
    document.body.classList.remove("overflow-hidden")
  }
}
